import React, { FunctionComponent, useEffect, useRef } from 'react';
import { Box, BoxProps, useTheme } from '@material-ui/core';
import customise from '../../../customise/constants/customise';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';
import useAdditionalScrollMargin from '../../../common/hooks/navigation/useAdditionalScrollMargin';

interface IScrollToWrapperProps extends BoxProps {
  target: string;
}

const ScrollToWrapper: FunctionComponent<IScrollToWrapperProps> = ({ target, children, ...props }) => {
  const { spacing } = useTheme<ISpcTheme>();
  const additionalScrollMargin = useAdditionalScrollMargin();
  const navigationRef = useRef(null);
  let sectionTopSpacing = navigationRef.current?.offsetHeight || spacing(6);
  sectionTopSpacing += additionalScrollMargin;

  useEffect(() => {
    navigationRef.current = document.getElementById(customise.NAVIGATION_BAR_ID);
  }, []);

  return (
    <Box id={`${customise.DOM_ID_PREFIX}${target}`} style={{ scrollMargin: sectionTopSpacing }} {...props}>
      {children}
    </Box>
  );
};

export default ScrollToWrapper;
